import React, { useMemo, useState } from 'react'
import Select from 'react-select'

import countries from 'i18n-iso-countries'

countries.registerLocale(require('i18n-iso-countries/langs/de.json'))

const localizedCountryNames = countries.getNames('de', { select: 'official' })

const countryOptions = Object.entries(localizedCountryNames).map(
  ([code, label]) => ({
    value: code,
    label,
  })
)
const CountrySelect = React.forwardRef(({ onChange, value, id, name }, ref) => {
  const selected = useMemo(
    () => countryOptions.find((option) => option.value === value),

    [value]
  )
  return (
    <Select
      id={id}
      name={name}
      options={countryOptions}
      ref={ref}
      onChange={(option) => onChange(option.value)}
      value={selected}
    />
  )
})

CountrySelect.displayName = 'CountrySelect'

CountrySelect.defaultProps = {
  value: 'DE',
  onChange: () => undefined,
}

export default CountrySelect
